export default __webpack_public_path__ + "static/media/connecttheroads.47400b3e.png";